/**
 * encrypt utils
 *
 * @author Shigq
 * @date 2019/11/22 11:22
 */
var instance = require('js-encrypt')

// PUB KEY
var PUBLIC_KEY = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCQVtKrwSgeA4ixBn1EShMB8QQ8EHO3BO/WgukAEV92O+OFOTIuaaKxP+YnI7dSQcGVCFvpWYdN87bkpBMPAjFYYcwpfZNU5tN1rZukIrfkkFh8nx0feOCdBnXoATDTX2NR0NvonwFamigs4xp5tDTEL/+Au3GyTcszW7HL/eoS3wIDAQAB";

/**
 * encrypt
 *
 * @param originalText
 * @param publicKey
 * @returns {*|void|string}
 */
function encrypt(originalText, publicKey) {
	var encrypt = new instance.JSEncrypt()
	var ciphertext = ''

	// set key
	publicKey = PUBLIC_KEY || publicKey
	// set public key
	encrypt.setPublicKey(publicKey)
	// encrypt original text
	ciphertext = encrypt.encrypt(originalText)
	// replace ciphertext from [+] to [-]
	ciphertext = ciphertext.replace(/\+/g, '-')

	return ciphertext
}


module.exports = {
	encrypt
}
